import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from'../Component/Header';  
import Footer from'../Component/Footer';   
const OurPrinciples = () => {  
  useEffect(() => {
    document.title = 'Our Principles - St. Francis Xavier School';  
}, []); 
    return (
        <>
        <Header/>
            <div className="innerslide">
                <ul className="breadcrumb">
                    <li><Link to="/"> Home</Link> </li>  
                    <li>School</li>
                    <li>Our Principles</li>
                </ul>
            </div> 
            <section className="innerbody">
            <div className="container"> 
                    <div className="row">
                    <div className="col-lg-12">
                    <ul className="mainlist">
                    <li> Giving primacy to character formation that leads to the choice of a life to serve.</li>
                 
                    <li> Quality education based on holistic principles for life.</li>
                 
                    <li> Building educational communities in a family atmosphere of partnership.</li>
                 
                    <li> Strategic participatory planning.</li>
                 
                    <li> Moving away from rote learning to meaningful assimilative learning.</li>
                 
                    <li> Involving students actively in the process of learning.</li>
                </ul>
                    </div>
                    </div> 
                </div>
           </section>
           <Footer/>
        </>
    );
}

export default OurPrinciples;
